import React from 'react'
import { useLanguage } from '~components'
import callPinkIcon from '../../../../assets/images/newimage/call-pink.svg'
import clockIcon from '../../../../assets/images/newimage/clock.svg'
import leafIcon from '../../../../assets/images/newimage/leaf.svg'
import callBlueIcon from '../../../../assets/images/newimage/call-blue.svg'
import vvIcon from '../../../../assets/images/newimage/vv.svg'
import lorderIcon from '../../../../assets/images/newimage/lorder.svg'
import arrowAIcon from '../../../../assets/images/newimage/arrow-a.svg'
import arrowBIcon from '../../../../assets/images/newimage/arrow-b.svg'

import {
  PageContainer,
  HeroSection,
  PageTitle,
  PageSubtitle,
  CallNowBtn,
  OrderOnlineText,
  SectionBlock,
  SectionTitle,
  ValueIconGrid,
  ValueIconCard,
  ValueIconLabel,
  StepsBlock,
  StepsRow,
  StepCircle,
  StepArrow,
  HowItWorksLabel,
  YellowBanner,
  BannerTitle,
  BannerSubtitle,
  FAQSection,
  FAQTitle,
  FAQGrid,
  FAQCard,
  FAQCardTitle,
  FAQCardText,
  BottomBar,
  BottomText,
  BottomBtn
} from './styles'

const DashedArrow = ({ src }) => (
  <img src={src} alt='arrow' style={{ width: '55px', height: '22px' }} />
)

export const DialABottle = () => {
  const [, t] = useLanguage()

  const faqItems = [
    {
      title: t('FAQ', 'FAQ'),
      text: t('FAQ_TEXT', 'Or enter your location above to order online')
    },
    {
      title: t('DEALS', 'Deals'),
      text: t('DEALS_TEXT', 'Check out our exclusive deals and offers for late night delivery.')
    },
    {
      title: t('HOW_TO_ORDER', 'How to Order'),
      text: t('HOW_TO_ORDER_TEXT', 'Simply call our number and place your order in minutes.')
    },
    {
      title: t('CONTACT', 'Y&Q'),
      text: t('CONTACT_TEXT', 'Have questions? Our team is available 24/7 to assist you.')
    }
  ]

  return (
    <PageContainer>

      {/* ── Hero ── */}
      <HeroSection>
        <PageTitle>{t('DIAL_A_BOTTLE_TITLE', 'DIAL A BOTTLE')}</PageTitle>
        <PageSubtitle>
          {t('DIAL_A_BOTTLE_SUBTITLE', 'Call now to place you order for delivery. Monstarat')}
        </PageSubtitle>
        <CallNowBtn href='tel:+14372688537'>
          {t('CALL_NOW', 'CALL NOW')}
        </CallNowBtn>
        <OrderOnlineText>
          {t('OR_ENTER_LOCATION_ABOVE', 'Or enter your location above to order online')}
        </OrderOnlineText>
      </HeroSection>

      {/* ── Value Icon Section ── */}
      <SectionBlock>
        <SectionTitle>{t('VALUE_ICON_SETTION', 'Value Icon Settion')}</SectionTitle>
        <ValueIconGrid>
          <ValueIconCard>
            <img src={callPinkIcon} alt='Call' style={{ width: '200px', height: '200px' }} />
            <ValueIconLabel>{t('FAST_PHANE_GRDERS', 'Fast Phane Grders')}</ValueIconLabel>
          </ValueIconCard>
          <ValueIconCard>
            <img src={clockIcon} alt='Clock' style={{ width: '200px', height: '200px' }} />
            <ValueIconLabel>{t('30_45_MINUTE_DELIVERY', '30-45 Minute Delivery')}</ValueIconLabel>
          </ValueIconCard>
          <ValueIconCard>
            <img src={leafIcon} alt='Leaf' style={{ width: '200px', height: '200px' }} />
            <ValueIconLabel>{t('NALOWIDE_CAVERAGE', 'Nalowide Caverage')}</ValueIconLabel>
          </ValueIconCard>
        </ValueIconGrid>
      </SectionBlock>

      {/* ── Steps row FIRST, then the "How It Works" label ── */}
      <StepsBlock>
        <StepsRow>
          <StepCircle><img src={callBlueIcon} alt='step1' style={{ width: '45px', height: '45px' }} /></StepCircle>
          <StepArrow><DashedArrow src={arrowAIcon} /></StepArrow>
          <StepCircle><img src={vvIcon} alt='step2' style={{ width: '45px', height: '45px' }} /></StepCircle>
          <StepArrow><DashedArrow src={arrowBIcon} /></StepArrow>
          <StepCircle><img src={lorderIcon} alt='step3' style={{ width: '45px', height: '45px' }} /></StepCircle>
        </StepsRow>
      </StepsBlock>

      <HowItWorksLabel>{t('HOW_IT_WORKS', 'How It Works')}</HowItWorksLabel>

      {/* ── Yellow Banner ── */}
      <YellowBanner>
        <BannerTitle>
          {t('BOTTLE_RUNNERS_REBOOT', 'Bottle Runners | Reboot the Night.')}
        </BannerTitle>
        <BannerSubtitle>
          {t('CALL_CONFIRM_DELIVERED', 'Call Confirm. Delivered.')}
        </BannerSubtitle>
      </YellowBanner>

      {/* ── FAQ Section ── */}
      <FAQSection>
        <FAQTitle>{t('FAQ_SECTION_TITLE', 'FAQ')}</FAQTitle>
        <FAQGrid>
          {faqItems.map((item, idx) => (
            <FAQCard key={idx}>
              <FAQCardTitle>{item.title}</FAQCardTitle>
              <FAQCardText>{item.text}</FAQCardText>
            </FAQCard>
          ))}
        </FAQGrid>
      </FAQSection>

      {/* ── Sticky Bottom Bar ── */}
      <BottomBar>
        <BottomText>{t('CALL_NOW', 'CALL NOW')}</BottomText>
        <BottomBtn onClick={() => { window.location.href = 'tel:+14372688537' }}>{t('DIAL_A_BOTTLE', 'DIAL A BOTTLE')}</BottomBtn>
      </BottomBar>

    </PageContainer>
  )
}

export default DialABottle
